import * as moment from 'moment';
import { Moment } from 'moment';
export class DateFormatter {

  static formatDateBeforeSend(value: any, hasMomentResult?: boolean): string | Moment {
    const result = (typeof value === 'string') ? moment(value) : moment({
      year: value.year,
      month: value.month - 1,
      day: value.day
    });

    if (!hasMomentResult) {
      return result.format('YYYY-MM-DD');
    }

    return result;
  }

}
